import React from 'react';

const CatalogoMuroBambooEspejo = () => {
  return (
    <section>
      <div className="container">
        <div className="title-style2 text-center mb-2-2 wow fadeIn" data-wow-delay="200ms">
          <h2 className="h1">Modelos de Paneles Decorativos Mirror</h2>
          <p>Explora nuestra colección de Paneles Decorativos Mirror, diseñados para añadir un toque moderno y sofisticado a cualquier espacio. 
            Nuestros modelos ofrecen elegancia y funcionalidad, adaptándose perfectamente a tus necesidades decorativas.</p>
          <p>
          ¡Contáctanos para más información o una cotización personalizada!</p>
          <p>Modelos disponibles:</p>
        </div>
        <div className="row gx-5 mt-n1-9 text-center">
          <div className="col-sm-6 col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="300ms">
            <div className="team-style1">
              <div className="team-img rounded image-hover">
                <img 
                  src="/assets/img/productos/muro-carbon-de-bambu/muro-carbon-de-bambu-catalogo-mirror-silver.jpg" 
                  alt="Mirror silver" 
                />
              </div>
              <div className="team-text">
                <div className="info rounded">
                  <h5>Mirror Plata</h5>
                  <span>Tamaño 1.22 x 2.44 mts.</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-6 col-lg-6 mt-1-9 wow fadeInUp" data-wow-delay="450ms">
            <div className="team-style1">
              <div className="team-img rounded image-hover">
                <img 
                  src="/assets/img/productos/muro-carbon-de-bambu/muro-carbon-de-bambu-catalogo-mirror-gray.jpg" 
                  alt="Mirror Gray" 
                />
              </div>
              <div className="team-text">
                <div className="info rounded">
                  <h5>Mirror Humo</h5>
                  <span>Tamaño 1.22 x 2.44 mts.</span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Si necesitas activar el tercer modelo, puedes descomentar este bloque */} 
          {/* 
          <div className="col-sm-6 col-lg-4 mt-1-9 wow fadeInUp" data-wow-delay="600ms">
            <div className="team-style1">
              <div className="team-img rounded image-hover">
                <img 
                  src="/assets/img/piso-vinilico-modelo-otro.jpg" 
                  alt="piso vinilico otro modelo" 
                />
              </div>
              <div className="team-text">
                <div className="info rounded">
                  <h5>Otro modelo</h5>
                  <span>Modelos: otro</span>
                </div>
              </div>
            </div>
          </div>
          */}
        </div>
      </div>
      <div className="circle-md right-10 top-35 border-secondary-color d-none d-lg-block"></div>
    </section>
  );
};

export default CatalogoMuroBambooEspejo;